import { CashbackPopups } from '@gamiphy/loyalty-station-desktop/store/cashbackPopups/enums';

export enum SignupSteps {
  UserInfo = 'userInfo',
  Otp = 'otp',
  Success = 'success'
}

export type CoretavaSession = {
  signupStep?: SignupSteps,
  unverifiedPhone?: string,
  lastActivityTime?: string,
  welcomeGiftNotification?: {
    opened: boolean,
  },
  popups?: {
    [key in CashbackPopups]?: {
      opened?: boolean,
      dismissed?: boolean
    }
  }
}
